//Based on es6-promise-debounce, just want a variable timeout.
export const variableDebounce = (func, immediate) => {
  let timeout;
  return (wait, ...args) => {
    return new Promise((resolve) => {
      const later = () => {
        timeout = null;
        if (!immediate) resolve(func(...args));
      };

      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) resolve(func(...args));
    });
  };
};
